import { router } from '@app/providers/router/router-provider';
import { useAuthToken } from '@modules/auth/sign-in-form/hooks/use-auth-token';
import type { AuthProvider } from '@shared/api';
import { Routes } from '@shared/constants/routes';
import { Flex, Spin } from 'antd';

import { useEffect, type FC } from 'react';

interface OauthPageProps {
  authType: AuthProvider;
}

export const OauthPage: FC<OauthPageProps> = ({ authType }) => {
  const { authByToken } = useAuthToken({
    onSuccess: async () => {
      const pendingInviteToken = localStorage.getItem('pendingInviteToken');
      if (pendingInviteToken) {
        router.navigate(Routes.authentication.invite.replace(':token', pendingInviteToken));
        return;
      }

      router.navigate(Routes.analytics.root);
    },
  });

  useEffect(() => {
    const handleAuth = async () => {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const accessToken = params.get('access_token');

      if (!accessToken) {
        console.error('Access token not found in URL');
        router.navigate(Routes.authentication.signIn);
        return;
      }

      try {
        await authByToken(accessToken, authType);

        window.history.replaceState(null, '', window.location.pathname);
      } catch (error) {
        console.error('Authentication failed:', error);
        router.navigate(Routes.authentication.signIn);
      }
    };

    handleAuth();
  }, []);

  return (
    <Flex style={{ height: '100%' }} flex={1} align="center" justify="center">
      <Spin />
    </Flex>
  );
};
